import { useEffect, useState } from 'react';
//import { useTranslation } from 'react-i18next';
import { useSearchParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { LoggerService } from '../../ui/utils';
import { getContent, getConsent } from '../../sdk/services/contentService';
import amwayLogo from '../../../src/assets/image/Amw_Logo_Black.webp';
//import { dateTimeToCustomFormat, UTCToLocal } from '../../ui/utils';
//import { Modal, TextAlign } from '../../ui/components';
import styles from './Terms.module.scss';
//import { any } from 'prop-types';

export interface ContentItem {
  campaign_id: string | null;
  terms_and_conditions: string;
}

export const TermsMain = () => {
  //const { t } = useTranslation();
  const [challengeTnC, setChallengeTnC] = useState('');
  const navigate = useNavigate();
  const [date, setDate] = useState('');
  const [searchParams] = useSearchParams();
  const campaignId = searchParams.get('cid');
  const cacheKey = 'TermsAndConditions';
  const cacheKeyCampaign = 'TermsAndConditionsCampaign';

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        if (campaignId) {
          const data = await getContent('challenge_details', cacheKeyCampaign, true);
          if (data && data.length > 0) {
            const challenge = campaignId ? data.find((item: ContentItem) => item.campaign_id === campaignId) : data[0];
            setChallengeTnC(challenge.terms_and_conditions || '');
            let date = moment(challenge.date).format('MMMM D, YYYY');
            setDate(date ?? '');
          }
        } else {
          const data = await getConsent(cacheKey, true);
          if (typeof data === 'object' && data !== null) {
            setChallengeTnC(data.terms_and_conditions ?? '');
            let date = moment(data.date).format('MMMM D, YYYY');
            setDate(date ?? '');
          }
        }
      } catch (error) {
        LoggerService.log('fetchPrivacyPolicy:Failed to retrieve content data. Using default content.');
      }
    };

    fetchPrivacyPolicy();
  }, [campaignId]);

  return (
    <>
      <div className={styles['term-container']}>
        <div className={styles['image-container']}>
          <img onClick={() => navigate('/')} className={styles['logo']} src={amwayLogo} alt="amway logo" height={30} />
        </div>
        <p className={styles['term-container-header']}>
          <b>We value your privacy</b>
        </p>

        <div className={styles['content-container']}>
          <div className={styles['content']}>
            {/* <h1 className={styles['security-privacy-header']}>{t('securityPrivacy.title')}</h1> */}
            <article className={styles['security-privacy-box']}>
              <h3 className={styles['security-privacy-box-header']}>
                <strong>Terms &amp; Conditions</strong>
              </h3>
              <p className={styles['security-privacy-box-date']}>
                <strong>Last Revised: {date}</strong>
              </p>
              {/* <p dangerouslySetInnerHTML={{ __html: t('securityPrivacy.article') }} /> */}
              <p dangerouslySetInnerHTML={{ __html: challengeTnC }} />
            </article>
          </div>
        </div>
      </div>
    </>
  );
};
